module.exports = __webpack_public_path__ + "img/phone-vibrate.6df96574.svg";